import { createFileRoute, redirect } from '@tanstack/react-router';

import {
  SIGN_OUT_FALLBACK,
  validateSignOutRedirectTo,
} from '@/utils/validate-sign-out-redirect';

/**
 * Signing out is now shared by both marketplace sides. Kept for existing links
 * and bookmarks while `/sign-out` becomes the canonical route — including the
 * legacy portal's account menu, which links here by absolute path.
 *
 * The `to` param is validated here as well as at the destination: forwarding
 * it unchecked would make this route an open-redirect hop of its own.
 */
export const Route = createFileRoute('/participants/sign-out')({
  validateSearch: (search): { to?: string } => {
    const to = validateSignOutRedirectTo(search.to);
    return to === SIGN_OUT_FALLBACK ? {} : { to };
  },
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/sign-out', search });
  },
});
